import "./App.css";
import "./responsive/breakpoint-1160px.css";
import "./responsive/breakpoint-992px.css";
import "./responsive/breakpoint-768px.css";
import "./responsive/breakpoint-576px.css";
import "./responsive/breakpoint-480px.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";
import React, { useLayoutEffect, lazy, Suspense, useEffect } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// Redux
import { Provider } from "react-redux";
import store from "./store";
import { loadUser } from "./actions/auth";
import setAuthToken from "./utils/setAuthToken";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

library.add(fas);

const LoadingPage = lazy(() => import("./components/LoadingPage"));
const Sidebar = lazy(() => import("./components/Sidebar"));
const Home = lazy(() => import("./components/Home"));
const Packages = lazy(() => import("./components/Packages"));
const Subscriptions = lazy(() => import("./components/Subscriptions"));
const Class = lazy(() => import("./components/Class"));
const Note = lazy(() => import("./components/Note"));
const AddSubscription = lazy(() => import("./components/AddSubscription"));
const Successful = lazy(() => import("./components/Successful"));
const Error = lazy(() => import("./components/Error"));
const ClassList = lazy(() => import("./components/ClassList"));
const GroupList = lazy(() => import("./components/GroupList"));
const Notifications = lazy(() => import("./components/Notifications"));
const ChangePassword = lazy(() => import("./components/ChangePassword"));
const Login = lazy(() => import("./components/Login"));
const Alert = lazy(() => import("./components/Alert"))

// cookies
const addCookie = () => {
  const cookieName = "plesk_technical_domain";
  const cookieValue = "1";

  if (!document.cookie.includes(`${cookieName}=${cookieValue}`)) {
    document.cookie = `${cookieName}=${cookieValue}`;
  }
};

function App() {
  useEffect(() => {
    // check for token in LS when app first runs
    if (localStorage.token) {
      // if there is a token set axios headers for all requests
      setAuthToken(localStorage.token);
    }
    // try to fetch a user, if no token or invalid token we
    // will get a 401 response from our API
    // store.dispatch(loadUser());

    // log user out from all tabs if they log out in one tab
    window.addEventListener("storage", () => {
      // if (!localStorage.token) store.dispatch({ type: LOGOUT });
    });
  }, []);

  useEffect(() => {
    store.dispatch(loadUser());
  }, []);

  useEffect(() => {
    addCookie();
  }, []);

  

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };

  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Suspense fallback={<LoadingPage />}>
            <Routes>
              <Route
                path="/"
                element={
                  <Wrapper>
                    <Sidebar />
                    <Alert />
                    <Outlet />
                  </Wrapper>
                }
              >
                <Route index element={<Home />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/subscriptions" element={<Subscriptions />} />
                <Route path="/class" element={<Class />} />
                <Route path="/note" element={<Note />} />
                <Route path="/addsubscription" element={<AddSubscription />} />
                <Route path="/successful" element={<Successful />} />
                <Route path="/error" element={<Error />} />
                <Route path="/classlist" element={<ClassList />} />
                <Route path="/grouplist" element={<GroupList />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/changepassword" element={<ChangePassword />} />
                {/* <Route path="*" element={<Alert />} /> */}
              </Route>
              <Route path="/login" element={<Login />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
